<template><div><h1>VUX V2.3.5 released</h1>
<h2><a href="/en/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[feature] Support slot:header #1381</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] Support slot:each-day</li>
</ul>
<h2><a href="/en/components/radio.html">Radio</a></h2>
<ul><li>[feature] Support slot:each-item</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[feature] Add slot:left</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] Fix repeat render bug #1458</li>
</ul>
<h2><a href="/en/components/tab.html">Tab</a></h2>
<ul><li>[feature] Support badge #1513</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.5 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.5-114.vue?24942062